import { delay } from "../helpers"

export function isNativeApp () {
  return window.navigator.userAgent.match(/Turbo Native/)
}

export async function waitForTurboBridge() {
  const TOTAL_TIME_TO_WAIT = 5000
  const TIME_TO_WAIT_BETWEEN_POLLS = 50
  const maxIterations = TOTAL_TIME_TO_WAIT / TIME_TO_WAIT_BETWEEN_POLLS

  // For native apps, we need to wait for Turbo Native to be initialized.
  // We poll for `window.turboNative` to be defined, and wait for 50ms between each poll up to 5000ms.
  for (let i = 0; i < maxIterations; i++) {
    if (window.turboNative) return

    await delay(TIME_TO_WAIT_BETWEEN_POLLS)
  }

  console.warn('Turbo Native bridge not available after timeout, proceeding anyway')
}
